import { Input } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { CustomFieldsType, ListingDetailsType } from '~addListing/types';
import { addListingDetailsType } from '~addListing/types';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { handleAttributeChange } from '~addListing/utils/handleAttributeChange';

const BathesNumber = ({
  listing,
  customFieldsData,
  errorAttributeIds,
  setErrorAttributeIds,
}: {
  listing: ListingDetailsType;
  customFieldsData: { attributes: CustomFieldsType[] };
  errorAttributeIds: number[];
  setErrorAttributeIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const { t } = useTranslation('app');
  const bathesKey = 'baths';
  const listingPropertyTypeId = listing?.property_type.id;
  const bathesData = customFieldsData.attributes?.find(
    (field: CustomFieldsType) => field.name === bathesKey,
  );
  const bathesDataId = Number(bathesData?.id);
  const isError = errorAttributeIds.includes(bathesDataId);
  const renderBathesNumber = Object.values(
    bathesData?.virtualPropertyTypesIds || {},
  ).includes(listingPropertyTypeId);

  const { setValue, getValues } = useFormContext<addListingDetailsType>();
  const defaultBathesNumberValue =
    listing?.attributes.find((att) => att.custom_field.id === bathesDataId)
      ?.value || 0;

  if (!renderBathesNumber) return null;

  useEffect(() => {
    setValue(
      'attributes',
      handleAttributeChange(
        getValues('attributes'),
        bathesDataId,
        defaultBathesNumberValue,
      ),
    );
  }, [isError]);

  return (
    <Input
      label={{
        text: t('bathesNumber'),
        className: 'text-title_4 text-black',
      }}
      field={{
        placeholder: t('bathesNumberPlaceholder'),
        className:
          'text-gray__dark_2 text-gray__dark_2 placeholder:text-gray__dark_1 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]',
        type: 'number',
        defaultValue:
          defaultBathesNumberValue !== 0 ? defaultBathesNumberValue : '',
        onChange: (e) => {
          const value = Number(e.target.value);
          if (value >= 0)
            handleAttributeChange(getValues('attributes'), bathesDataId, value);
          else handleAttributeChange(getValues('attributes'), bathesDataId, 0);
        },
        min: 0,
        onFocus: () =>
          setErrorAttributeIds((prev) =>
            prev.filter((id) => id !== bathesDataId),
          ),
        onWheel: (e) => (e.target as HTMLInputElement).blur(),
      }}
      error={isError ? t('bathesNumberError') : undefined}
    />
  );
};

export default BathesNumber;
